import { makeStyles } from '@material-ui/core/styles';

const useStyles = {
  common: makeStyles((theme) => ({
    tooltipOpenButton: {
      backgroundColor: 'white',
      marginTop: theme.typography.pxToRem(-2),
      minWidth: 'auto',
      padding: 0,

      '&:hover': {
        backgroundColor: 'white',
      },
    },
    tooltipCloseButton: {
      backgroundColor: 'white',
      minWidth: 'auto',
      padding: 0,

      '&:hover': {
        backgroundColor: 'white',
      },
      [theme.breakpoints.between('md', 'lg')]: {
        display: 'none',
      },
    },
  })),
  tooltip: makeStyles((theme) => ({
    popper: {
      pointerEvents: 'unset',
    },
    tooltip: {
      alignItems: 'flex-start',
      backgroundColor: 'white',
      borderRadius: '5px',
      boxShadow: '0 4px 25px 4px rgba(6,21,86,0.15)',
      color: theme.palette.grey1,
      display: 'flex',
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      maxWidth: theme.typography.pxToRem(262),
      padding: theme.typography.pxToRem(15),
      position: 'relative',

      '& .MuiTooltip-arrow': {
        color: 'white',
      },
    },
  })),
};

export default useStyles;
